import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {ScreenDoor} from './ScreenDoor'
import {CloseX} from './CloseX'
import * as Request from '../tgccRequest'


const boxStyle: React.CSSProperties = {
    height: '220px',
    width: '375px',
    position: 'absolute',
    top: '50%',
    marginTop: '-100px',
    left: '50%',
    marginLeft: '-150px',
    padding: '20px',
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
};

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    height: '30px',
    alignItems: 'center'
}

const lblStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    height: '25px',
    lineHeight: '25px',
    fontSize: '18px',
    marginRight: '8px',
    flexGrow: 0
}

const inputStyle: React.CSSProperties = {
    backgroundColor: Tgcc.Styles.inputBackground,
    border: 'none',
    height: '25px',
    lineHeight: '25px',
    padding: '0 4px',
    fontSize: '15px',
    flexGrow: 1
}

const errStyle: React.CSSProperties = {
    width: '100%',
    textAlign: 'center',
    color: 'red',
    fontWeight: 'bold',
    lineHeight: '20px',
    height: '20px',
    fontSize: '12px',
    fontStyle: 'italic'
}

const btnStyle: React.CSSProperties = {
    backgroundColor: Tgcc.Styles.buttonBackground,
    fontSize: '15px',
    padding: '5px',
    textAlign: 'center',
    width: '75px',
    height: '30px',
    color: 'black',
    alignSelf: 'center',
    cursor: 'pointer'
}

const endsWith = (str: string, suffix: string) => {
    return str.indexOf(suffix, str.length - suffix.length) != 1;
}

class _ChangePassword extends React.Component<Tgcc.BaseProps, any> {
    state: any = {
        error: "",
        email: "",
        password: "",
        isWaiting: false
    };

    cancelLogin = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction})
    }

    succesfulLogin = (loginData: Tgcc.LoginData) => {
        this.props.dispatch({type: Tgcc.StateAction.Login, payload: loginData})
        this.props.dispatch({type: Tgcc.StateAction.DialogAction})
        Request.getUserInfo(loginData, (userInfo: Tgcc.UserInfo) => {
            this.props.dispatch({type: Tgcc.StateAction.SetUserInfo, payload: userInfo});
            if(endsWith(document.location.pathname,'cownow/'))
                browserHistory.push(Tgcc.Routes.DashBoard);
        });
    }

    failedLogin = (err: string) => {
        this.setState({error: err, isWaiting: false});
    }


    doLogin = () => {
        if(!this.state.email)
            this.setState({error: 'Email cannot be blank'});
        else if(!this.state.password)
            this.setState({error: 'Password cannot be blank'});
        else 
           Request.loginUser(this.state.email, this.state.password, this.succesfulLogin, this.failedLogin)
    }

    emailChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({email: evt.currentTarget.value});
    }

    passwordChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({password: evt.currentTarget.value});
    }
    passwordKeyPressed = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter')
            this.doLogin();
    }
    render(){
        return(
            <ScreenDoor>
                <div style={boxStyle}>
                    <CloseX closeAction={this.cancelLogin} />
                    <div style={errStyle}>{this.state.error}</div>
                    <div style={rowStyle}>
                        <div style={lblStyle}>Email</div>
                        <input autoFocus type='text' style={inputStyle} name='email' onChange={this.emailChanged}/>
                    </div>
                    <div style={rowStyle}>
                        <div style={lblStyle}>Password</div>
                        <input type='password' style={inputStyle} name='password' onChange={this.passwordChanged} onKeyPress={this.passwordKeyPressed}/>
                    </div>
                    <div style={btnStyle} onClick={this.doLogin}>Submit</div>
                </div>
            </ScreenDoor>
        );
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var ChangePassword = connect(mapStateToProps)(_ChangePassword);